import type { IFetchRequest } from '../../interface/fetch';
import type { IChannelID } from '../../util/interface/channel';
import type { IMessageBase } from './base';

export const MESSAGE_TYPE = 'CACHE_FETCH';

export interface ICallbackMessage {
    error?: string;
    progress: number;
    done: boolean;
}

export interface IMessageFetchToCachePayload extends IMessageBase {
    type: 'CACHE_FETCH';
    payload: {
        requests: Array<IFetchRequest>;
        cacheName?: string;
        callbackChannel?: IChannelID | undefined;
    };
}
